<mat-card class="card-login  mat-elevation-z5">
  <mat-card-title>
    <div class="flex-center" style="margin-top: 20px;">
      Benutzerverwaltung
    </div>
  </mat-card-title>
  @if (globserv.Login.Admin) {
    <div style="margin-top: 50px;" >
      @if (pasuraUsers!=undefined) {
        <div >
          <table style="width:100%; margin-top: 20px; cursor: default;" >
            @for (u of pasuraUsers; track u) {
              <tr  >
                <th [ngClass]="{'rowGray': 0 === idx % 2}" ng-class="{waiting: globserv.runstatus=='running'}" class= "tabContentLeft1">{{u.UserID}}</th>
                <th class= "tabContentLeft2">{{u.EMail}}</th>
                <th class= "tabContentLeft2">{{(u.Admin)? "Admin":""}}</th>
                <th class= "tabContentLeft2">{{(u.Aktiv)? "aktiv":"inaktiv"}}</th>
                <!--
                <th style="cursor: pointer;"> <mat-icon aria-hidden="false" aria-label="downoad File">save_alt</mat-icon></th>
                -->
              </tr>
            }
            <tr>
            </table>
            <div style="margin-top:20px">
              <mat-divider></mat-divider>
            </div>
          </div>
        }
      </div>
    }

    <form #fPasswort="ngForm" >

      <mat-form-field class="flex-center">
        <input matInput placeholder="Altes Passwort"  class="Feld" [(ngModel)]="passwortAlt"  name="Password" type="password" required minlength="3" >
      </mat-form-field>

      <mat-form-field class="flex-center">
        <input matInput placeholder="Neues Passwort"  class="Feld" [(ngModel)]="passwortNeu"  name="PasswordNeu" type="password" required minlength="3" >
      </mat-form-field>

      <mat-form-field class="flex-center">
        <input matInput placeholder="Neues Passwort wiederholen"  class="Feld" [(ngModel)]="passwortNeu2"  name="PasswordNeu2" type="password" >
      </mat-form-field>


      <div class='flex-center' >
        <button mat-flat-button [disabled]="!fPasswort?.valid ||  (passwortNeu2!=passwortNeu)"	color="primary"(click)="doChangePW()" style="width: 200px; margin-top: 50px; margin-bottom: 20px;">Passwort ändern</button>
      </div>
    </form>
  </mat-card>

